const QUOTE_ID_KEY = "quoteID";

const quoteIDsOfOrdersOnThisPage = new Map<string, string>();

export const getQuoteIDFromSession = (spaceOrMembershipID?: string) => {
  if (spaceOrMembershipID) {
    return (
      quoteIDsOfOrdersOnThisPage.get(spaceOrMembershipID) ||
      sessionStorage.getItem(`${QUOTE_ID_KEY}_${spaceOrMembershipID}`) ||
      undefined
    );
  }

  return undefined;
};

export const setQuoteIDToSession = (
  quoteID?: string,
  spaceOrMembershipID?: string
) => {
  const currentQuoteID = getQuoteIDFromSession(spaceOrMembershipID);

  if (quoteID && quoteID !== currentQuoteID) {
    if (spaceOrMembershipID) {
      quoteIDsOfOrdersOnThisPage.delete(spaceOrMembershipID);
    }
    sessionStorage.setItem(`${QUOTE_ID_KEY}_${spaceOrMembershipID}`, quoteID);
  }
};

export const removeQuoteIDFromSession = (spaceOrMembershipID?: string) => {
  if (spaceOrMembershipID) {
    quoteIDsOfOrdersOnThisPage.delete(spaceOrMembershipID);
    sessionStorage.removeItem(`${QUOTE_ID_KEY}_${spaceOrMembershipID}`);
  }
};

export const keepQuoteIDOnThisPageOnly = (
  quoteID?: string,
  spaceOrMembershipID?: string
) => {
  if (quoteID && spaceOrMembershipID) {
    removeQuoteIDFromSession(spaceOrMembershipID);
    quoteIDsOfOrdersOnThisPage.set(spaceOrMembershipID, quoteID);
  }
};
